<nz-layout>
  <nz-sider
    nzTheme="light"
    nzCollapsible
    [nzCollapsedWidth]="isMobile ? 0 : size"
    [(nzCollapsed)]="isCollapsed"
    [nzWidth]="250"
    [nzTrigger]="null"
    >
    <a class="logo" routerLink="/">
      @if (!isCollapsed) {
        <img
          class="logo-icon"
          src="/assets/images/logo.svg"
          alt=""/>
      }
      @if (isCollapsed) {
        <img
          class="logo-icon"
          src="/assets/images/logo-mini.svg"
          alt=""/>
      }
    </a>
    <ul nz-menu nzTheme="light" nzMode="inline" class="sider-menu">
      <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: navigation }"></ng-container>
      <ng-template #menuTpl let-menus>
        @for (menu of menus; track menu) {
          @if (!menu.children) {
            <li
              class="menu-item"
              nz-menu-item
              *ngxPermissionsOnly="menu.role || []"
              [nzPaddingLeft]="menu.level * 24"
              [nzDisabled]="menu.disabled"
              [nzSelected]="menu.selected"
              [routerLink]="menu.url"
              nzMatchRouter
              nz-tooltip
              nzTooltipPlacement="right"
              [nzTooltipTitle]="isCollapsed && menu.type === 'item' ? (menu.translate | translate) : ''"
              nzSelected
              >
              @if (menu.icon) {
                <span nz-icon [nzType]="menu.icon"></span>
              } @else {
                <span style="color: #989898; font-size: 12px" nz-icon nzType="right" nzTheme="outline"></span>
              }
              <span >{{ menu.translate | translate }}</span>
            </li>
          } @else {
            <li
              nz-submenu
              [nzPaddingLeft]="menu.level * 24"
              [nzOpen]="menu.open"
              [nzTitle]="menu.translate | translate"
              [nzIcon]="menu.icon"
              [nzDisabled]="menu.disabled"
              *ngxPermissionsOnly="menu.role || []"
              [routerLink]="menu.url"
              nzMatchRouter
              >
              <ul style="font-size: 12px;">
                <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }" />
              </ul>
            </li>
          }
        }
      </ng-template>
      <!--      <ng-container *ngFor="let nav of navigation">-->
      <!--        <ng-container-->
      <!--          *ngIf="nav.children && nav.children.length; else singleNav"-->
      <!--        >-->
      <!--          <li-->
      <!--            nzMenuClassName="main-item"-->
      <!--            nz-submenu-->
      <!--            *ngxPermissionsOnly="nav.role || []"-->
      <!--          >-->
      <!--            <span title-->
      <!--              ><i *ngIf="nav.icon" nz-icon [nzType]="nav.icon"></i-->
      <!--              ><span class="main-item">{{-->
      <!--                nav.translate | translate-->
    <!--              }}</span></span-->
    <!--            >-->
    <!--            <ul>-->
    <!--              <ng-container *ngFor="let navChild of nav.children">-->
    <!--                <li-->
    <!--                  *ngxPermissionsOnly="navChild.role || []"-->
    <!--                  [id]="navChild.id"-->
    <!--                  nz-menu-item-->
    <!--                  style="font-size: 12px"-->
    <!--                  [routerLink]="navChild.url"-->
    <!--                  routerLinkActive="ant-menu-item-selected"-->
    <!--                  [routerLinkActiveOptions]="{ exact: true }"-->
    <!--                >-->
    <!--                  {{ navChild.translate | translate }}-->
  <!--                </li>-->
<!--              </ng-container>-->
<!--            </ul>-->
<!--          </li>-->
<!--        </ng-container>-->
<!--        <ng-template #singleNav>-->
<!--          <li-->
<!--            nz-menu-item-->
<!--            [id]="nav.id"-->
<!--            [routerLink]="nav.url"-->
<!--            *ngxPermissionsOnly="nav.role || []"-->
<!--            routerLinkActive="ant-menu-item-selected"-->
<!--          >-->
<!--            <i *ngIf="nav.icon" nz-icon [nzType]="nav.icon"></i>-->
<!--            <span>{{ nav.translate | translate }}</span>-->
<!--          </li>-->
<!--        </ng-template>-->
<!--      </ng-container>-->
</ul>
</nz-sider>
<nz-layout>
  <nz-header>
    <div nz-flex nzGap="small" nzJustify="space-between" nzAlign="center">
      @if (size === 0 && isCollapsed) {
        <div  nz-col nzFlex="initial">
          <a class="logo" routerLink="/cashier">
            <img class="logo-icon" src="/assets/images/logo-mini.svg" />
          </a>
        </div>
      }
      <div nz-col nzFlex="initial">
        <i
          class="trigger"
          nz-icon
          [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
          (click)="isCollapsed = !isCollapsed"
        ></i>
      </div>

      <div nz-col nzFlex="auto"></div>

      <div
        nz-col
        nzFlex="initial"
        *ngxPermissionsOnly="['Admin', 'Manager']"
        >
        <nz-space>
          @if (isMobile){
            <span *nzSpaceItem class="current-cashier-pending" nz-icon nzType="info-circle" nzTheme="twotone" (click)="openImportantInfo()"></span>
          } @else {
            <nz-alert
              *nzSpaceItem
              class="current-cashier-pending"
              style="cursor: pointer"
              nzShowIcon
              nzType="info"
              [nzMessage]="'ALERT.important_info' | translate"
              (click)="openImportantInfo()"
            ></nz-alert>
          }
        </nz-space>
      </div>
      <div nz-col nzFlex="initial">
        <div class="ant-btn-group">
          <button
            nz-button
            nz-dropdown
            [nzDropdownMenu]="profile"
            nzPlacement="bottomRight"
            >
            <i nz-icon nzType="user"></i>
            @if (!isMobile) {
              {{ authUser?.username }}
            }
          </button>
        </div>
        <nz-dropdown-menu #profile="nzDropdownMenu">
          <ul nz-menu style="min-width: 150px">
            <li nz-menu-item routerLink="/admin" *ngxPermissionsOnly="['Admin', 'Manager']">
              {{ 'header.account.dropdown.admin' | translate }}
            </li>
            <li nz-menu-item routerLink="/profile">
              {{ 'header.account.dropdown.profile' | translate }}
            </li>
            <li nz-menu-divider></li>
            <li nz-menu-item (click)="logout()">
              <nz-space>
                <i *nzSpaceItem nz-icon nzType="logout" nzTheme="outline"></i>
                <span *nzSpaceItem>{{
                  'header.account.dropdown.logOut' | translate
                }}</span>
              </nz-space>
            </li>
          </ul>
        </nz-dropdown-menu>

        <nz-dropdown-menu #branchMenu="nzDropdownMenu">
          <ul nz-menu>
            @if (branches$ | async; as branches) {
              @for (branch of branches; track branch) {
                <li
                  nz-menu-item
                  (click)="setBranch(branch)"
                  >
                  {{ branch.name }}
                </li>
              }
            }
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
  </nz-header>
  <nz-content>
    <router-outlet></router-outlet>
  </nz-content>
  <nz-footer nzTheme="light">
    {{ 'footer.title' | translate }} WebApp.Ge - {{ version }}
  </nz-footer>
</nz-layout>
</nz-layout>


<ng-template #notificationBtnTpl let-notification>
  <button nz-button nzType="primary" nzSize="small" (click)="notification.close(true)">Open</button>
</ng-template>
